import { createQueryKeys } from "@lukemorales/query-key-factory"

import axios from "@/api/axios"
import { APIFn } from "@/api/utils"

import { AuthData, UserOTP, VerifyUserOTP } from "./types"

export const AuthQueryKey = createQueryKeys("auth", {
  sendOTP: () => ({
    queryKey: ["send-OTP"],
  }),
  verifyOTP: () => ({
    queryKey: ["verify-OTP"],
  }),
})

type Resource = {
  tokens: {
    generate: APIFn<AuthData>
    refresh: APIFn<AuthData>
    verify: APIFn<{
      verified: boolean
      organizationId: string | null
      userId: string | null
    }>
  }
  sendOTP: APIFn<UserOTP>
  verifyOTP: APIFn<VerifyUserOTP>
}

export const AuthResource: Resource = {
  tokens: {
    generate: ({ data, ...config }) =>
      axios.post("/solis/v1/auth/user-tokens/", data, {
        ...config,
      }),
    refresh: ({ data, ...config }) =>
      axios.post("/solis/v1/auth/refresh-token/", data, {
        headers: {
          Authorization: null,
        },
        ...config,
      }),
    verify: ({ data, ...config }) =>
      axios.post("/solis/v1/auth/access-tokens/verify/", data, {
        headers: {
          Authorization: null,
        },
        ...config,
      }),
  },

  sendOTP: ({ data, ...config }) =>
    axios.post("/solis/v1/users/otp/", data, { ...config }),

  verifyOTP: async ({ data, ...config }) =>
    axios.post("/solis/v1/users/otp/verify/", data, {
      headers: {
        "device-id": "temp",
        platform: "suraasa-web",
      },
      ...config,
    }),
}
